import { render, staticRenderFns } from "./assIncorporation.vue?vue&type=template&id=3442051a&scoped=true"
import script from "./assIncorporation.vue?vue&type=script&lang=js"
export * from "./assIncorporation.vue?vue&type=script&lang=js"
import style0 from "./assIncorporation.vue?vue&type=style&index=0&id=3442051a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3442051a",
  null
  
)

export default component.exports